import React from 'react';

import Footer from '../c/Footer';

const Inspiration = () => {
	return (
		<React.Fragment>
			<iframe style={{
					display: "block",
					height: "100vh",
					width: "100vw",
					border: "none",
				}}
				src="https://inspiration.aktiedysten.dk/test-til-mmj" title="stock inspiration universe" />
		</React.Fragment>
	);
}

export default Inspiration;



// WEBPACK FOOTER //
// ./src/p/Inspiration.js